import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NavigationService } from '@services/navigation-service/navigation-service.service';

@Component({
    selector: 'app-button-goback',
    imports: [MatIconModule, MatButtonModule],
    template: `
    <button (click)="goBack()" color="primary" mat-button>
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>
  `,
    styleUrls: ['./button-goback.component.css']
})
export class ButtonGobackComponent {
  private navigationService = inject(NavigationService);
  private router = inject(Router);


  /** Si viene una ruta, se utilizará para navegar */
  @Input() returnUrl?: string | any[];

  goBack(): void {
    if (this.returnUrl) {
      // Permite string o array de rutas
      this.router.navigate(Array.isArray(this.returnUrl) ? this.returnUrl : [this.returnUrl]);
      return;
    }

    // Si no viene ruta → retrocede
    this.navigationService.back();
  }
}
